<template>
  <div>
    <QS-h4-title title="应收信息" />
    <el-form
      :model="addFormData"
      ref="addFormData"
      label-width="150px"
      :rules="formRule"
      class="customerInfo"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item
            label="付款方类型:"
            prop="customerType"
          >
            <span>
              {{ customerTypeName }}
            </span>
          </el-form-item>
          <el-form-item label="付款方" prop="customerId">
            <span>{{ customer.customerName }}</span>
          </el-form-item>
          <el-form-item
            prop="completeTime"
            label="收款单完成时间"
          >
            <el-date-picker
              v-model="addFormData.completeTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="input-w"
              type="datetime"
              placeholder="请选择收款单完成时间"
              clearable
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label='付款凭证'  prop="attachment">
            <div class="upload">
              <UploadCommon
                fileTitle="(付款凭证)"
                :multiple="true"
                :limit="6"
                :fileList.sync="addFormData.attachment"
                :sizeType="4"
                listType="text"
                @uploadBefore="uploadBefore"
                @uploadSuccess="uploadSuccess"
                @uploadError="uploadError"
                commonUpload
                group="finance"
                code="finance_pay_agreement_pic"
              >
              </UploadCommon>
            </div>
          </el-form-item>
          <el-form-item label="备注" class="alone">
            <el-input
              type="textarea"
              v-model="addFormData.remarks"
              placeholder="请输入"
              clearable
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
</div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import moment from 'moment'

export default {
  inject: ['orderData'],
  data() {
    return {
      formRule: {
        completeTime: [
          {
            required: true,
            message: '请选择收款单完成时间',
            trigger: 'blur',
          },
        ],
        attachment: [
          {
            required: true,
            message: '付款凭证不能为空',
            trigger: 'change',
          },
        ],
      },
      // 时间选择器限制
      pickerOptions: {
        disabledDate(time) {
          // 收款单完成时间 不能选择当前日期之后的时间【PKXW-2685】
          return time.getTime() > Date.now()
        },
      },
      addFormData: {
        attachment: [], // 收款凭证
        customerType: '',
        customerId: '',
        completeTime: moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss'),
        remarks: '',
      },
    }
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    'addFormData.attachment': {
      handler() {
        this.$refs.addFormData.validateField('attachment')
      },
      deep: true,
    },
  },
  computed: {
    // 付付款方类型名称
    customerTypeName() {
      return selectOption.customerTypeDict[this.customer.customerType]
    },
    // 收付款方类型
    // eslint-disable-next-line vue/no-unused-properties
    customerTypeList() {
      return this.dictParseList(selectOption.customerTypeDict)
    },
  },
  methods: {
    uploadBefore() {
      this.$emit('uploading')
    },
    uploadSuccess() {
      this.$emit('uploaded')
    },
    uploadError() {
      this.$emit('uploaded')
    },
  },
}
</script>

<style lang="scss" scoped>
.input-w {
  width: 100%;
  max-width: 204.5px;
}
.customer-name {
  float: left;
  width: 150px;
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-right: 1px solid #000;
  margin: 0;
}
.contact-tel {
  float: left;
  color: #8492a6;
  font-size: 13px;
  margin: 0;
  padding-left: 10px;
}
  .guide{
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
  }
</style>
